export default {"src":"/_next/static/media/close-menu.4a13a93d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};